<template>
	<div class="intro-wrapper">
		<component
			:is="character"
			ref="character"
			v-bind="$attrs"
			:buttons="[{ text: button_text, action: next }]"
		/>
	</div>
</template>

<script>
import { isOneOf } from "@/lib/validators";
import Enzo from '@/components/partials/Enzo';
import Bunny from '@/components/partials/Bunny';

export default {
	name: 'CharacterIntro',
	components: {
		Enzo,
		Bunny,
	},
	props: {
		character: {
			type: String,
			required: true,
			validator: isOneOf(["Enzo", "Bunny"]),
		},
		button_text: {
			type: String,
			required: true,
		},
	},
	methods: {
		next() {
			this.$refs.character.pushState("exiting", () => this.$router.push('/game/intros/next'));
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/scenes/CharacterIntro.vue